import { MIXED_UNIT_TYPE } from '@/hooks';

// Unit-type labels and dropdown options, built from one domain's unit-type map.

const MIXED_LABEL_KEY = 'UNIT_MIXED';

export const UNIT_TYPES = Object.freeze({
  working: 'working',
  declaration: 'declaration',
  tracking: 'tracking',
});

/** Builders for one domain's unit types, keyed unitType → i18n label key. */
export const createUnitTypeOptions = (labelKeys) => {
  const unitTypes = Object.keys(labelKeys);
  const [firstUnitType] = unitTypes;

  const unitTypeLabel = (t, unitType) =>
    unitType === MIXED_UNIT_TYPE
      ? t(MIXED_LABEL_KEY)
      : t(labelKeys[unitType] ?? labelKeys[firstUnitType]);

  const buildUnitTypeOptions = (t) =>
    unitTypes.map((unitType) => ({ value: unitType, label: unitTypeLabel(t, unitType) }));

  // Only the units the row's material has; the unit itself rides along on a badge.
  const buildRowUnitOptions = (t, byUnit) =>
    unitTypes
      .filter((unitType) => byUnit?.[unitType]?.unit)
      .map((unitType) => ({
        value: unitType,
        label: unitTypeLabel(t, unitType),
        badgeText: byUnit[unitType].unit,
      }));

  // "Mixed" is a readout, so it is listed only in that state and never selectable.
  const buildUnitHeaderOptions = (t, headerUnitType) => [
    ...buildUnitTypeOptions(t),
    ...(headerUnitType === MIXED_UNIT_TYPE
      ? [{ value: MIXED_UNIT_TYPE, label: t(MIXED_LABEL_KEY), disabled: true }]
      : []),
  ];

  return { unitTypeLabel, buildUnitTypeOptions, buildRowUnitOptions, buildUnitHeaderOptions };
};

// Working + declaration — every table except inbound shipments.
export const WORKING_DECLARATION_LABEL_KEYS = Object.freeze({
  [UNIT_TYPES.working]: 'UNIT_WORKING',
  [UNIT_TYPES.declaration]: 'UNIT_DECLARATION',
});
